/* Swipe left/right on touch screens to move the arrow carousels. Reuses each carousel's own prev/next buttons. */
(function () {
  if (window.__swipeNavInit) return;
  window.__swipeNavInit = true;

  var configs = [
    { viewport: '[data-aid-products-viewport]', scope: '.aid-products', prev: '[data-aid-products-prev]', next: '[data-aid-products-next]' },
    { viewport: '[data-pdp-viewport]', scope: '.pdp-related', prev: '[data-pdp-prev]', next: '[data-pdp-next]' },
    { viewport: '[data-ih-viewport]', scope: '.ih-shop__panel', prev: '[data-ih-prev]', next: '[data-ih-next]' },
    { viewport: '.aid-techniques__wrapper', scope: '.aid-techniques', prev: '[data-aid-technique-prev]', next: '[data-aid-technique-next]' }
  ];

  function attach(viewport, cfg) {
    var startX = 0;
    var startY = 0;
    var swiped = false;

    function button(which) {
      var scope = viewport.closest(cfg.scope) || document;
      return scope.querySelector(which === 'next' ? cfg.next : cfg.prev);
    }

    viewport.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
    }, { passive: true });

    viewport.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var btn = button(dx < 0 ? 'next' : 'prev');
      if (btn) btn.click();
      swiped = true;
      setTimeout(function () { swiped = false; }, 350);
    });

    // a swipe that starts on a product card must not also open it
    viewport.addEventListener('click', function (e) {
      if (!swiped) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  configs.forEach(function (cfg) {
    document.querySelectorAll(cfg.viewport).forEach(function (vp) { attach(vp, cfg); });
  });
})();
